import React, {
  CSSProperties, FC,
} from 'react';
import { faSpinner, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Colors } from './@types';

interface ButtonComponentProps {
  className?: string;
  color?: Colors;
  disabled?: boolean;
  elevated?: boolean;
  height?: number | string;
  icon?: IconDefinition;
  id?: string;
  loading?: boolean;
  name?: string;
  onClick?: () => void;
  size?: 'small' | 'normal' | 'big';
  style?: CSSProperties;
  title?: string;
  type?: 'reset' | 'submit' | 'button';
  variant?: 'contained' | 'outlined' | 'default';
  width?: number | string;
}

const Button: FC<ButtonComponentProps> = (({
  children,
  className = undefined,
  color = 'primary',
  disabled,
  elevated,
  icon,
  id,
  loading,
  name,
  onClick,
  size,
  style,
  title,
  type = 'button',
  variant = 'default',
  width,
}) => {
  const cls = {
    btn: true,
    'btn-sm': size === 'small',
    'btn-big': size === 'big',
    'btn-icon': icon,
    elevated,
  };

  const stl: CSSProperties = {
    ...(width ? { width } : {}),
    ...style,
  };

  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      disabled={disabled || loading}
      name={name}
      className={clsx(
        cls,
        className,
        variant === 'contained' && `bg-${color} border-${color} ${
          color.includes('gray') ? 'color-black' : 'color-white'}`,
        variant === 'outlined' && `bg-white color-${color} border-${color}`,
        variant === 'default' && `bg-white color-${color} border-white`,
      )}
      id={id}
      onClick={onClick}
      style={stl}
      title={title}
    >
      {
        loading && <FontAwesomeIcon spin icon={faSpinner} data-cy="loading-btn" />
      }
      {
        !loading && (icon
          ? <FontAwesomeIcon icon={icon} />
          : children
        )
      }
    </button>
  );
});

export default Button;
